export function formatTotalCharges(initialValue?: string | number): string {
  let value = initialValue || "";
  if (value === undefined || value === "") {
    return "";
  }

  if (typeof value === "number") {
    value = value.toString();
  }

  // remove leading and finishing 0
  while (value.startsWith("0")) {
    value = value.substring(1);
  }

  if (value.includes(".")) {
    while (value.endsWith("0")) {
      value = value.substring(0, value.length - 1);
    }
  }

  if (!value || value === ".") {
    return "";
  }

  // add leading 0 before .
  if (value.startsWith(".")) {
    value = `0${value}`;
  }

  // remove finishing .
  if (value.endsWith(".")) {
    value = value.substring(0, value.length - 1);
  }

  return value;
}
